export default __webpack_public_path__ + "static/media/GenderIcon.db48a027.svg";